/**
 * カテゴリー一覧の表示パーツ
 *  - SP表示用のアコーディオン開閉処理
 */
export default class CategoryList extends HTMLElement {
  constructor() {
    super();

    this.listBlock = this.querySelector('.unico-category-block');
    this.accButton = this.querySelector('.unico-button');

    this.accButton?.addEventListener('click', () => {
      this.toggleOpen();
    });
  }

  toggleOpen() {
    if (this.accButton.classList.contains('-is-active')) {
      this.accButton.classList.remove('-is-active');
      this.listBlock.classList.remove('-is-active');
      this.accButton.innerHTML = 'すべてのカテゴリー';

      this.listBlock.closest('.unico-section-inner').scrollIntoView({
        behavior: 'smooth',
      });
    } else {
      this.accButton.classList.add('-is-active');
      this.listBlock.classList.add('-is-active');
      this.accButton.innerHTML = '閉じる';
    }
  }
}
